import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import User from 'models/user';

const propTypes = {
  user: PropTypes.instanceOf(User).isRequired,
  isDefault: PropTypes.bool.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
};

const LicensePlateModalDefaultVehicleCheckbox = ({
  user,
  isDefault,
  onCheckboxClick,
}) => {
  if (!user.isLoggedIn()) { return null; }

  const checkboxClasses = cx({
    checkbox: true,
    selected: isDefault,
  });

  return (
    <div className={checkboxClasses} onClick={onCheckboxClick}>
      <label className="text-weight-book noselect">
        <FormattedMessage
          id="common.set-default-vehicle"
          defaultMessage="This is my main ride."
        />
      </label>
    </div>
  );
};

LicensePlateModalDefaultVehicleCheckbox.propTypes = propTypes;
export default LicensePlateModalDefaultVehicleCheckbox;
